
// src/helpers/mixpanel.js

import mixpanel from 'mixpanel-browser'
export default mixpanel



// WEBPACK FOOTER //
// ./src/helpers/mixpanel.js